import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalIaNotApprovedRulesPage } from './modal-ia-not-approved-rules.page';

const routes: Routes = [
  {
    path: '',
    component: ModalIaNotApprovedRulesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalIaNotApprovedRulesPageRoutingModule {}
